module.exports = __webpack_public_path__ + "img/about-colzani.png?4a91637185c6d9d583ce3f99e5c4db41";